import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setUserData } from "./UserSlice";

const initialState = {
  userPlanDetails: {},
  planId: "",
  remaining: "",
  variants: {
    variant_count: 0,
    total_variant: 0,
    remaning: 0,
  },
  textFieldsNum: false,
  textFieldsName: false,
};

// Async thunk action to get plan details from API
export const getPlanDetails = createAsyncThunk(
  "userPlan/getPlanDetails",
  async (_, {dispatch, rejectWithValue }) => {
    try {
      const token = localStorage.getItem("Login");
      const userDetails = JSON.parse(
        localStorage.getItem("user_login_details")
      );

      const data = {
        email: userDetails?.email,
      };

      const response = await fetch(
        process.env.REACT_APP_API_PATH + "user/data",
        {
          body: JSON.stringify(data),
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const val = await response.json();

      if (+val.resultFlag === 1) {
        const userDetails = val?.response?.user;
        const userPlanDetails = val?.response?.userPlan;
        const variants = val?.response?.variants;
        dispatch(setUserData({userData: userDetails}))
        return { userPlanDetails, variants: { ...variants }, userDetails};
      } else {
        return rejectWithValue("Failed to fetch plan details");
      }
    } catch (error) {
      return rejectWithValue(`Error in getting user details: ${error.message}`);
    }
  }
);

const planDetailSlice = createSlice({
  name: "userPlan",
  initialState,
  reducers: {
    setPlanDetails: (state, action) => {
      const { userPlanDetails } = action.payload;
      state.userPlanDetails = userPlanDetails;
    },
    setVariationCountDetails: (state, action) => {
      state.variants = action.payload;
    },
    setAllData: (state, action) => {
      const { userPlanDetails, variants } = action.payload;
      state.userPlanDetails = userPlanDetails;
      state.variants = variants;
    },
    updateName: (state, action) => {
      state.textFieldsName = action.payload;
    },
    updateNum: (state, action) => {
      state.textFieldsNum = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlanDetails.pending, (state) => {
        // Handle loading state if needed
      })
      .addCase(getPlanDetails.fulfilled, (state, action) => {
        const { userPlanDetails, variants, userDetails } = action.payload;
        state.userPlanDetails = userPlanDetails;
        state.variants = variants;
      })
      .addCase(getPlanDetails.rejected, (state, action) => {
        // Handle error state if needed
        console.error("Failed to get plan details:", action.payload);
      });
  },
});

export const {
  updateName,
  updateNum,
  setAllData,
  setPlanDetails,
  setVariationCountDetails,
} = planDetailSlice.actions;

export default planDetailSlice.reducer;
